import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { mapGetters } from 'vuex';
import getJsonLD, { TYPES } from '~/helpers/json-ld';
const getProductJsonLD = getJsonLD(TYPES.PRODUCT);
export default {
  name: 'ProductJsonLD',
  props: {
    product: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    scriptJsonLD() {
      const product = _objectSpread({}, this.product, {
        url: this.url,
        currency: this.locale.currency
      });

      return {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(getProductJsonLD(product)),
        body: true
      };
    }

  }),

  head() {
    return {
      script: [this.scriptJsonLD]
    };
  },

  render: h => h(null)
};